import React from "react";
import { useNavigate } from "react-router-dom";
import { Grid, _ } from "gridjs-react";
import { html } from "gridjs";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Card, CardBody, CardHeader, Col, Container, Row, Button, Modal, ModalBody, ModalHeader } from "@/Components/ui";
;
import { API, BACKEND_HOST } from "../../../api";
import moment from "moment";
import UsageSection from "../../../Components/B2Busage";
import { dialogService } from "@/utils/dialogService";
export default function PreCouponList() {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [fields, setFields] = React.useState([]);
    const [delRecord, setDelRecord] = React.useState(null);
    const [modalDelete, setModalDelete] = React.useState(false);
    function tog_delete() {
        setModalDelete(!modalDelete);
    }
    const handleEdit = (id) => {
        navigate(`/precoupon-form/${id}`);
    };
    const handleManageSales = (id) => {
      navigate(`/precoupon-form/${id}?tab=sales`);
    };
    const handleCopy = (id) => {
        navigate(`/precoupon-form/${id}?copy=true`);
    };
    const handleDelete = (id) => {
        setDelRecord(id);
        tog_delete();
    };
    // Event listeners for gridjs button clicks
    React.useEffect(() => {
        const handleEditEvent = (e) => {
            handleEdit(e.detail);
        };
        const handleSalesEvent = (e) => {
          handleManageSales(e.detail);
        };
        const handleCopyEvent = (e) => {
            handleCopy(e.detail);
        };
        const handleDeleteEvent = (e) => {
            handleDelete(e.detail);
        };
        window.addEventListener('editPreCoupon', handleEditEvent);
        window.addEventListener('managePreCouponSales', handleSalesEvent);
        window.addEventListener('copyPreCoupon', handleCopyEvent);
        window.addEventListener('deletePreCoupon', handleDeleteEvent);
        return () => {
            window.removeEventListener('editPreCoupon', handleEditEvent);
          window.removeEventListener('managePreCouponSales', handleSalesEvent);
            window.removeEventListener('copyPreCoupon', handleCopyEvent);
            window.removeEventListener('deletePreCoupon', handleDeleteEvent);
        };
      }, [navigate, modalDelete]);
    React.useEffect(() => {
        API.get(`${BACKEND_HOST}/precoupon/precoupon/`)
            .then((res) => {
            const data = res.data;
            console.log(data);
            const fieldList = ["id", "name", "discount", "reserv_start_date", "reserv_end_date", "expire_date", "is_active", "available_packages"];
            // const replaceFieldList = ["id", "예약교환권명", "금액제한", "예약가능일(시작)", "예약가능일(종료)","만기일",  "활성상태", "사용가능한 예약상품"]
            // tmpFields = tmpFields.filter((item) => fieldList.includes(item.name))
            // tmpFields = tmpFields.map((item) => {
            //     return {
            //         ...item,
            //         name: replaceFieldList[fieldList.indexOf(item.name)],
            // 		formatter: (cell) => _(<div>{cell}</div>)
            //     }
            // })
            // tmpFields = tmpFields.sort((a, b) => fieldList.indexOf(b.name) - fieldList.indexOf(a.name) )
            let tmpFields = [
                {
                    name: "id",
                    formatter: (cell) => html(`<span style="white-space: pre-line;" class="fw-semibold">${cell}</span>`),
                },
                {
                    name: "예약교환권명",
                    formatter: (cell) => html(`<span style="white-space: pre-line;" class="fw-semibold">${cell}</span>`),
                },
                {
                    name: "금액제한",
                    formatter: (cell) => html(`<span style="white-space: pre-line;" class="fw-semibold">${cell}</span>`),
                },
                {
                    name: "예약가능일(시작)",
                    formatter: (cell) => html(`<span style="white-space: pre-line;" class="fw-semibold">${moment(cell).format("Y-MM-DD")}</span>`),
                },
                {
                    name: "예약가능일(종료)",
                    formatter: (cell) => html(`<span style="white-space: pre-line;" class="fw-semibold">${moment(cell).format("Y-MM-DD")}</span>`),
                },
                {
                    name: "만기일",
                    formatter: (cell) => html(`<span style="white-space: pre-line;" class="fw-semibold">${moment(cell).format("Y-MM-DD")}</span>`),
                },
                {
                    name: "활성상태",
                    formatter: (cell) => html(`<span style="white-space: pre-line;" class="fw-semibold">${cell ? "활성" : "비활성"}</span>`),
                },
                {
                    name: "해당 예약상품",
                    formatter: (cell) => html(`<span style="white-space: pre-line;" class="fw-semibold">${cell}</span>`),
                },
            ];
            tmpFields.push({
                name: "Actions",
                width: "200px",
                formatter: (cell) => {
                    const safeId = Number(cell);
                    if (!Number.isFinite(safeId)) {
                        return html('');
                    }
                    return html(`<div class="d-flex gap-2">
                <div class="sales">
                  <button class="btn btn-sm btn-primary" onclick="window.dispatchEvent(new CustomEvent('managePreCouponSales', {detail: ${safeId}}))">판매설정</button>
                </div>
                <div class="edit">
                  <button class="btn btn-sm btn-success edit-item-btn" onclick="window.dispatchEvent(new CustomEvent('editPreCoupon', {detail: ${safeId}}))">수정</button>
                </div>
                <div class="copy">
                  <button class="btn btn-sm btn-info copy-item-btn" onclick="window.dispatchEvent(new CustomEvent('copyPreCoupon', {detail: ${safeId}}))">복사</button>
                </div>
                <div class="remove">
                  <button class="btn btn-sm btn-danger remove-item-btn" onclick="window.dispatchEvent(new CustomEvent('deletePreCoupon', {detail: ${safeId}}))">삭제</button>
                </div>
              </div>`);
                },
            });
            setFields(tmpFields);
            let dataArr = [];
            data.forEach((item) => {
                console.log(item);
                let itemValues = [];
                fieldList.forEach((field) => {
                    itemValues.push(item[field]);
                });
                itemValues.push(item.id);
                dataArr.push(itemValues);
            });
            setData(dataArr);
        })
            .catch((e) => console.log(e));
    }, []);
    const deleteRecord = () => {
        API.delete(`${BACKEND_HOST}/precoupon/precoupon/${delRecord}/`)
            .then(async (res) => {
            await dialogService.handleAlert("Delete ok!");
            history.go(0);
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    };
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="예약교환권 목록" pageTitle="예약교환권"/>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <h4 className="card-title mb-0 flex-grow-1">예약교환권 목록</h4>
                  <div>
                    <Button color="success" className="add-btn me-1" onClick={() => {
            navigate(`/precoupon-form/${0}`);
        }} id="create-btn">
                      <i className="ri-add-line align-bottom me-1"></i> 생성
                    </Button>
                    {/* <Button className="btn btn-soft-danger"
                    // onClick="deleteMultiple()"
                    ><i className="ri-delete-bin-2-line"></i></Button> */}
                  </div>
                </CardHeader>

                <CardBody>
                  <UsageSection productType="precoupon"/>

                  <div id="table-gridjs">
                    <Grid data={data} columns={fields} search={true} sort={true} pagination={{ enabled: true, limit: 10 }}/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Remove Modal */}
      <Modal isOpen={modalDelete} onClose={() => {
            // tog_delete();
        }} centered>
        <ModalBody className="text-center p-5">
          <div className="mt-4">
            <h4 className="mb-3">Are you Sure ?</h4>
            <p className="text-muted mb-4">{`Are you Sure You want to Remove this Record(id:${delRecord}) ?`}</p>
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={() => {
            setDelRecord(null);
            setModalDelete(false);
        }}>
                Cancel
              </Button>
              <Button color="danger" onClick={deleteRecord}>
                Delete
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>);
}
